<template>
    <div id="overview">
        <div class="loading" v-if="!isLoaded"></div>
        <div v-if="is_empty" class="empty">{{empty_msg}}</div>
        <!-- 事件 -->
        <div class="events" v-else>
            <!-- <div class="events" v-if="match_data.events.length != 0"> -->
            <template v-if="events_show">
                <section>{{ $t('events') }}</section>
                <div class="content content_p">
                    <span class="icon_start"></span>
                    <!-- 时间轴 -->
                    <ol id="timeline">
                        <li class="cf">
                            <span class="dot_s"></span>
                        </li>
                        <li v-for="(item, index) in match_data.events" :key="index" class="cf">
                            <span class="num">{{ item.minute }}</span>
                            <!-- 主队 -->
                            <div v-if="item.teamAEvents.length !== 0" class="home">
                                <span class="arrow"></span>
                                <p v-for="(team,index) in item.teamAEvents" :key="index">
                                    <!-- :href="team.person_href" -->
                                    <span class="person">
                                        <span class="text_lim"> {{ team.person }} </span>
                                        <img :src="getImgSrc(team.event_pic)"/>
                                    </span>
                                </p>
                            </div>
                            <!-- 客队 -->
                            <div v-if="item.teamBEvents.length !== 0" class="away">
                                <span class="arrow"></span>
                                <p v-for="(team, index) in item.teamBEvents" :key="index">
                                    <!-- :href="team.person_href" -->
                                    <span class="person">
                                        <img :src="getImgSrc(team.event_pic)"/>
                                        <span class="text_lim"> {{ team.person }} </span>
                                    </span>
                                </p>
                            </div>
                        </li>
                    </ol>
                    <span class="dot"></span>
                    <span class="icon_end"></span>
                </div>
                <div class="show">
                    <div class="show_main">
                        <span><img src="../assets/match/icon_goal.png" alt="">{{ $t('goal') }}</span>
                        <span><img src="../assets/match/icon_point.png" alt="">{{ $t('penalty') }}</span>
                        <span><img src="../assets/match/icon_point_1.png" alt="">{{ $t('penaltySaved') }}</span>
                        <span><img src="../assets/match/icon_w.png" alt="">{{ $t('ownGoal') }}</span>
                        <span><img src="../assets/match/icon_a.png" alt="">{{ $t('assist') }}</span>
                    </div>
                </div>
            </template>
            <!-- 统计 -->
            <template v-if="statistics_show">
                <section>{{ $t('statistics') }}</section>
                <div class="status">
                    <table class="head">
                        <tbody>
                        <tr>
                            <th class="away">
                                <!-- :href="match_data.statistics.team_A.href" -->
                                <span class="team">
                                    <span class="text_lim">{{ match_data.statistics.team_A.name }}</span>
                                    <img :src="getImgSrc(match_data.statistics.team_A.logo)"
                                         @error="showDefault($event)" alt=""/>
                                </span>
                            </th>
                            <th class="name">&nbsp;</th>
                            <th class="home">
                                <!-- :href="match_data.statistics.team_B.href" -->
                                <span class="team">
                                    <img :src="getImgSrc(match_data.statistics.team_B.logo)"
                                         @error="showDefault($event)" alt=""/>
                                    <span class="text_lim">{{ match_data.statistics.team_B.name }}</span>
                                </span>
                            </th>
                        </tr>
                        </tbody>
                    </table>
                    <table v-if="statistics_show">
                        <tbody>
                        <tr v-for="(item,index) in match_data.statistics.list" :key="index">
                            <td class="away">
                                <span class="num">{{ item.team_A.value }}</span>
                                <span class="rank">
                                    <span class="ranks" :class="item.team_A.class"
                                          :style="{width:item.team_A.per + '%'}"></span>
                                </span>
                            </td>
                            <td class="name">{{ item.type }}</td>
                            <td class="home">
                                <span class="rank">
                                    <span class="ranks" :class="item.team_B.class"
                                          :style="{width:item.team_B.per + '%'}"></span>
                                </span>
                                <span class="num">{{ item.team_B.value }}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
    // 低版本客户端会调用本方法，sentry下会报错
    // window.setHeight = function () {
    //     console.log('setHeight');
    // };
    //
    // window.videoIsPlaying = function () {
    //     return false;
    // };

    export default {
        name: 'overview',
        props: ['matchId'],
        data () {
            return {
                match_data: {
                    statistics: {
                        team_A: {},
                        team_B: {}
                    }
                },
                isLoaded: false,
                is_empty: false,
                empty_msg: '',
                statistics_show: false,
                events_show: false
            };
        },
        computed: {
            matchOverviewFormation () {
                return this.$store.state.matchDetailStore.matchOverviewFormation;
            }
        },
        created () {
            if (this.matchOverviewFormation) {
                this.match_data = this.matchOverviewFormation;
                this.isLoaded = true;
                if (this.matchOverviewFormation.status === 'Fixture' || this.matchOverviewFormation.status === 'Postponed') {
                    this.is_empty = true;
                    this.empty_msg = this.$t('notPrepared');
                    return;
                }
                if (this.matchOverviewFormation.statistics && this.matchOverviewFormation.statistics.team_A && this.matchOverviewFormation.statistics.team_B) {
                    this.statistics_show = true;
                }
                if (this.matchOverviewFormation.events && this.matchOverviewFormation.events.length !== 0) {
                    this.events_show = true;
                }
                if (!this.statistics_show && !this.events_show) {
                    this.is_empty = true;
                    this.empty_msg = this.$t('noData');
                }
            } else {
                this.isLoaded = true;
                this.is_empty = true;
                this.empty_msg = this.$t('noData');
            }
        },
        methods: {
            showDefault (team) {
                let defaultImg = require('../assets/match/defaultTeam.png');
                event.target.src = defaultImg;
            },
            getHost () {
                let hostname = location.hostname;
                let obj = {
                    'localhost': 'https://api-test.allfootballapp.com',
                    'test-n.allfootballapp.com': 'https://api-test.allfootballapp.com',
                    'beta-n.allfootballapp.com': 'beta-api.allfootballapp.com',
                    'n.allfootballapp.com': 'api.allfootballapp.com'
                };
                return obj[hostname];
            }
        }
    };
</script>
<style scoped>
    html,
    body {
        -webkit-touch-callout: none;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 15px;
        padding: 0;
        margin: 0;
        color: #333;
        background-color: #eff1f4;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        /* iOS position:fixed; elements fix (not 100%) */
        min-height: 100%;
        overflow-x: hidden;
    }

    .events {
        background-color: #f5f5f5;
    }

    section {
        display: block;
        /* vertical-align:middle; */
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        font-weight: 400;
        padding: 0 0 0 15px;
        margin: 0;
        /*color: 555;*/
        background-color: #e2e4e6;
    }

    .content {
        margin: 10px 15px;
    }

    a {
        color: #399e5c;
        text-decoration: none;
    }

    .person {
        color: black;
        text-decoration: none;
    }

    p {
        line-height: 1.6;
        text-align: justify;
        word-wrap: break-word;
        word-break: normal;
        margin: 20px 0;
    }

    ul,
    li,
    dl,
    dt,
    dd {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    header h1 {
        font-size: 20px;
        padding: 0;
        margin: 0;
        line-height: 1.5;
    }

    header time {
        color: #999;
        font-size: 12px;
        display: inline-block;
        padding: 0;
        vertical-align: top;
        margin-left: 6px;
    }

    header h2 {
        line-height: 20px;
        font-size: 12px;
        padding: 5px 0 0 0;
        font-weight: normal;
        margin: 0;
    }

    article video {
        display: block;
        margin: 0 auto;
        width: 100%;
        /* background: url() #3e3e3e no-repeat center center; */
        background-size: 118px;
    }

    .media-iframe {
        text-indent: 0;
        display: block;
        margin: 0 auto;
        width: 100%;
        min-height: 100px;
    }

    .media-container {
        display: block;
        position: relative;
        z-index: 1000;
        margin: 0 auto;
    }

    .media-container-video {
        border-bottom: 25px #000 solid;
        border-top: 25px #000 solid;
    }

    .media-holder {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url('../assets/match/play@80x80.png') no-repeat center center;
        background-size: 40px 40px;
    }

    .media-holder-video {
        background: url('../assets/match/video.png') no-repeat center center;
        background-size: 60px 60px;
    }

    .floater {
        float: left;
        height: 50%;
        margin-bottom: -10px;
    }

    .empty {
        clear: both;
        height: 20px;
        position: relative;
        text-align: center;
        color: #babdc2;
        font-size: 14px;
    }

    ol,
    li {
        margin: 0;
        padding: 0;
    }

    ol#timeline {
        width: 100%;
        padding-bottom: 20px;
        background: url('../assets/match/bg_line.png') center center repeat-y;
    }

    ol#timeline li {
        position: relative;
        color: #555;
        margin: 10px 0;
        margin-top: 20px;
    }

    ol#timeline li div {
        width: 40%;
        border: 1px solid #ddd;
        /*no*/
        padding: 5px 0;
        background: #fff;
        position: relative;
        border-radius: 3px;
    }

    ol#timeline p {
        margin: 0;
        padding: 0;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        text-indent: 0;
    }

    ol#timeline p img {
        width: 15px;
        vertical-align: middle;
    }

    .content_p {
        padding-bottom: 41px;
    }

    .show {
        width: 100%;
        font-size: 12px;
        /*height:14px;*/
        padding-top: 13px;
        line-height: 14px;
        border-top: 1px solid #e9e9e9;
        /*no*/
        background: #eff1f4;
    }

    .show_main {
        padding: 0 15px;
    }

    .show img {
        width: 12px;
        vertical-align: top;
        margin-right: 3px;
    }

    .show span {
        display: inline-block;
        text-align: left;
        margin-bottom: 13px;
    }

    .show_main {
        text-align: justify;
        text-justify: distribute-all-lines;
        /*ie6-8*/
        text-align-last: justify;
        /* ie9*/
        -moz-text-align-last: justify;
        /*ff*/
        -webkit-text-align-last: justify;
        /*chrome 20+*/
    }

    /* chrome*/

    @media screen and (-webkit-min-device-pixel-ratio: 0) {
        .show_main:after {
            content: "";
            display: inline-block;
            overflow: hidden;
            width: 0;
            height: 0;
        }
    }

    .cf:before,
    .cf:after {
        content: "";
        display: table;
    }

    .cf:after {
        clear: both;
    }

    .cf {
        zoom: 1;
        clear: both;
        padding: 0;
    }

    ol#timeline .home {
        float: left;
        text-align: right;
        padding-right: 10px;
    }

    ol#timeline .home p {
        text-align: right;
        font-size: 12px;
    }

    ol#timeline .home span.arrow {
        display: block;
        width: 6px;
        height: 8px;
        background: url('../assets/match/tri_l.png') 0 0 no-repeat;
        position: absolute;
        right: -6px;
        top: 5px;
        background-size: cover;
    }

    ol#timeline .away {
        float: right;
        text-align: left;
        padding-left: 10px;
        line-height: 15px;
    }

    ol#timeline .away span.arrow {
        display: block;
        width: 6px;
        height: 8px;
        background: url('../assets/match/tri_r.png') 0 0 no-repeat;
        position: absolute;
        left: -6px;
        top: 5px;
        background-size: cover;
    }

    ol#timeline .away p {
        text-align: left;
    }

    ol#timeline .num {
        display: block;
        width: 20px;
        height: 20px;
        left: 0;
        right: 0;
        position: absolute;
        margin: auto;
        background: #16ac3a;
        border-radius: 10px;
        color: #fff;
        text-align: center;
        line-height: 20px;
        font-weight: 400;
        font-family: arial;
        font-size: 10px;
    }

    .content .act {
        display: block;
        width: 100%;
        height: 20px;
        color: #16ac3a;
        text-align: center;
        line-height: 20px;
        font-weight: 400;
        font-size: 14px;
        margin-top: 5px;
    }

    .content .dot {
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #16ac3a;
        margin: -5px auto 0 auto;
    }

    .content .dot_s {
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #16ac3a;
        margin: 0 auto 0 auto;
    }

    ol#timeline > li:first-child {
        margin-top: 5px;
    }

    .icon_start {
        display: block;
        margin: 0 auto;
        width: 16px;
        height: 16px;
        background: url('../assets/match/icon_start.png') 0 0 no-repeat;
        background-size: 100%;
    }

    .icon_end {
        display: block;
        margin: 5px auto 0 auto;
        width: 16px;
        height: 16px;
        background: url('../assets/match/icon_end.png') 0 0 no-repeat;
        background-size: 100%;
    }

    .status {
        width: 96%;
        margin: 0 auto;
        padding: 0;
    }

    .status table {
        margin: 0;
        padding: 0;
        width: 100%;
        word-break: keep-all;
    }

    .status table.head {
        border-bottom: 1px solid #ddd;
        /*no*/
    }

    .status th,
    .status td {
        margin: 0;
        padding: 0;
        width: 100%;
        border-collapse: collapse;
        font-weight: 400;
        font-size: 12px;
        border: 0;
    }

    .status th {
        height: 40px;
        line-height: 40px;
    }

    .status td {
        height: 16px;
        line-height: 16px;
        padding: 7px 0;
        font-family: arial;
        color: #333;
    }

    .status a {
        color: #333;
    }

    .status th img {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        margin: 0;
        padding: 0;
    }

    .status .away {
        width: 43%;
        text-align: right;
        text-overflow: ellipsis;
    }

    .status .home {
        width: 43%;
        text-align: left;
        text-overflow: ellipsis;
    }

    .status .name {
        width: 14%;
        text-align: center;
    }

    .status .rank {
        margin: 0 1px;
        display: inline-block;
        width: 77%;
        height: 12px;
        line-height: 12px;
        background: #e9e9e9;
        border-radius: 1px;
        vertical-align: top;
        margin-top: 2px;
    }

    .status .ranks {
        display: inline-block;
        height: 12px;
        line-height: 12px;
        background: #16ac3a;
        border-radius: 1px;
        vertical-align: top;
    }

    .status .ranks_l {
        background: #888;
    }

    span.text_lim {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        line-break: strict;
        vertical-align: middle;
        text-overflow: ellipsis;
        width: 90px;
    }

    .empty {
        padding-top: 36%;
    }

    .video {
        position: relative;
    }

    .video .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: url(https://dqdfiles.b0.upaiyun.com/app/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);
        background-size: auto 20px;
        z-index: 10000;
        display: none;
    }

    .playing .mask {
        display: block;
    }

    .playing .media-holder-video {
        display: none;
    }

    /*code for css*/

    ul.gif_container {
        min-height: 200px;
        padding: 15px 10px 10px;
        font-size: 0;
    }

    ul.gif_container li {
        background: #FFFFFF;
        display: inline-block;
        width: 49%;
        min-height: 100px;
        margin-bottom: 8px;
        overflow: hidden;
        font-size: 0;
        vertical-align: middle;
    }

    ul.gif_container li:nth-child(even) {
        margin-left: 2%;
    }

    ul.gif_container li .img_con {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% auto;
        height: 128px;
        width: 100%;
    }

    ul.gif_container li .text_con {
        font-size: 12px;
        margin: 0;
        padding: 8px 8px 10px;
        height: 52px;
        position: relative;
    }

    ul.gif_container li .text_con p {
        margin: 0;
        height: 30px;
        line-height: 15px;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    ul.gif_container li a {
        display: block;
        color: #333333;
    }

    ul.gif_container li a:visited {
        color: #999999;
    }

    .total_view {
        position: absolute;
        left: 8px;
        bottom: 10px;
        color: #16ac3a;
    }

    .comments {
        position: absolute;
        right: 8px;
        bottom: 10px;
        color: #999999;
    }

    .gif {
        background-image: url('../assets/match/3x_gif_icon.png');
        background-position: center center;
        background-size: 20px 20px;
        height: 20px;
        width: 20px;
        display: block;
        z-index: 2000;
    }

    #app_news {
        background: #fff;
    }

    #app_news dd {
        padding: 0 14px;
    }

    #app_news dd {
        border-top: 1px solid #eeeeee;
        /*no*/
        height: 72px;
    }

    #app_news dd a {
        display: block;
        color: #333;
        height: 52px;
        padding: 10px 0;
        position: relative;
    }

    #app_news dd a:visited {
        color: #999999;
    }

    #app_news dd span {
        color: #aaa;
        font-size: 11px;
        position: absolute;
        right: 0;
        bottom: 9px;
    }

    #app_news dd .img_news {
        background-color: #e9e9e9;
        width: 70px;
        height: 52px;
        float: left;
        margin-right: 10px;
        background-position: center center;
        background-size: 100%;
    }

    #app_news dd .video_news {
        width: 70px;
        height: 52px;
        border-radius: 2px;
        float: left;
        margin-right: 12px;
        background-position: center center;
        background-size: 100%;
    }

    #app_news dd .video_icon {
        background: url(https://dqdfiles.b0.upaiyun.com/app/video.png) center center no-repeat rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        background-size: 20px 20px;
    }

    #app_news p {
        padding: 0 0 3px 0;
        line-height: 18px;
        margin: 0;
        font-size: 14px;
        position: relative;
        bottom: 2px;
    }

    .loading {
        position: absolute;
        width: 45px;
        height: 45px;
        background: url('../assets/match/loading-icon.png') no-repeat;
        background-size: 100%;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>




// WEBPACK FOOTER //
// matchOverview.vue?27134aa1